import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCodeClassicRoute: InvariantJiraRoute = {
	name: 'software-code-classic',
	path: '/jira/software/c/projects/:projectKey/code',
};
